import { Component, EventEmitter, inject, Output } from '@angular/core';
import { MaskitoOptions } from '@maskito/core';
import { BaseComponent } from '../../../../../models/base/base-component';
import { VerifyMfaViewModel } from './verify-mfa-view-model';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { createVerificationCodeFormGroup } from '../../../forms/verification-code-form-group';

@Component({
  selector: 'app-verify-mfa',
  templateUrl: './verify-mfa.component.html',
  styleUrls: ['./verify-mfa.component.scss', '../auth.component.scss'],
  providers: [VerifyMfaViewModel]
})
export class VerifyMfaComponent extends BaseComponent {
  public viewModel = inject(VerifyMfaViewModel);

  @Output() loadingOpts = new EventEmitter<LoadingOptions>();

  public formGroup = createVerificationCodeFormGroup();
  public formSubmitted = false;

  public readonly codeMaskOptions: MaskitoOptions = {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
  };

  public customErrorMessages = {
    code: {
      exactLength: $localize`Verification code must be 6 digits`
    }
  };

  constructor() {
    super();
  }

  setupBindings(): void {
    this.viewModel.loadingOpts$.subscribeWhileAlive({
      owner: this,
      next: opts => this.loadingOpts.emit(opts)
    });
  }

  setupViews(): void {}

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.viewModel.req$.once(req => {
      req.timeBasedOneTimePassword = this.formGroup.controls.code.value;
      this.viewModel.formSubmitted(req);
    });
  }
}
